// extracted by mini-css-extract-plugin
export default {"logo-container":"Logo_logo-container__f1pxg"};